import { childEnvironment } from './environment';

export const getEnvironmentBase = () => ({});